import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  CUSTOMER_RMA_CREDIT_AMOUNT,
  CUSTOMER_RMA_TYPE,
  PARTIAL_CREDIT_AMT
} from "MODULES/RMAsAndWarranties/constants";

export default function validate(values, props) {
  return validator(values, form => {
    if (values.partial_credit_status) {
      form.validate(PARTIAL_CREDIT_AMT).satisfies(rules.required);
    }

    if (values.credit_issued && props.rma.type === CUSTOMER_RMA_TYPE) {
      form.validate(CUSTOMER_RMA_CREDIT_AMOUNT).satisfies(rules.required);
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/VendorRmaCreditSection/validate.js